import React, { useEffect, useState } from "react";
import { api, formatIDR } from "@/lib/api";
import { toast } from "sonner";
import { PageHeader, StatCard, Card, Btn, Input } from "@/components/erp/ui";
import { Banknote, TrendingUp, Wallet, Receipt, FileSpreadsheet, FileText } from "lucide-react";
import { SpecialReport } from "@/components/erp/finance/SpecialReport";
import { PoPayments } from "@/components/erp/finance/PoPayments";
import { DailyRelease } from "@/components/erp/finance/DailyRelease";
import { SalesEntertain } from "@/components/erp/sales/SalesEntertain";
import Bank from "@/pages/erp/Bank";

const download = async (month, fmt) => {
  try {
    const res = await api.get("/finance/report", { params: { month, fmt }, responseType: "blob" });
    const a = document.createElement("a"); a.href = URL.createObjectURL(res.data); a.download = `laporan-keuangan-${month}.${fmt}`; a.click();
  } catch { toast.error("Gagal membuat laporan"); }
};

const Summary = ({ d }) => (<>
  <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
    <StatCard icon={Banknote} label="Revenue" value={formatIDR(d.revenue)} accent="text-emerald-600" />
    <StatCard icon={TrendingUp} label="Gross Profit" value={formatIDR(d.gross_profit)} accent={d.gross_profit >= 0 ? "text-emerald-600" : "text-rose-600"} />
    <StatCard icon={Wallet} label="Payroll" value={formatIDR(d.payroll)} />
    <StatCard icon={Receipt} label="Receivable" value={formatIDR(d.receivable)} />
  </div>
  <Card className="p-6 mt-6">
    <h3 className="font-head font-semibold mb-4">Profit & Loss (ringkas)</h3>
    <div className="space-y-2.5 font-mono text-sm max-w-md">
      <div className="flex justify-between"><span className="text-slate-500">Revenue (approved)</span><span className="text-emerald-600">{formatIDR(d.revenue)}</span></div>
      <div className="flex justify-between"><span className="text-slate-500">Payroll Cost</span><span className="text-rose-600">-{formatIDR(d.payroll)}</span></div>
      <div className="flex justify-between border-t border-slate-200 pt-2.5 font-semibold text-base"><span>Gross Profit</span><span>{formatIDR(d.gross_profit)}</span></div>
      <div className="flex justify-between"><span className="text-slate-500">Project Budget</span><span>{formatIDR(d.project_budget)}</span></div>
    </div>
  </Card>
  <SpecialReport />
</>);

export default function Finance() {
  const [d, setD] = useState(null); const [tab, setTab] = useState("summary");
  const [month, setMonth] = useState(new Date(Date.now() + 7 * 36e5).toISOString().slice(0, 7));
  useEffect(() => { api.get("/finance/summary").then(({ data }) => setD(data)).catch(() => {}); }, []);
  if (!d) return <div className="text-slate-400 font-mono text-sm">Loading…</div>;
  return (
    <div>
      <PageHeader title="Finance" subtitle="Ringkasan keuangan, Kas Bank & tagihan PO — terhubung dengan quotation, project, purchasing & payroll."
        action={<div className="flex flex-wrap items-center gap-2" data-testid="finance-download">
          <Input type="month" data-testid="finance-report-month" value={month} onChange={(e) => e.target.value && setMonth(e.target.value)} className="border border-slate-300 rounded-lg px-2 py-1.5 text-xs" />
          <Btn variant="ghost" data-testid="finance-dl-xlsx" onClick={() => download(month, "xlsx")}><FileSpreadsheet className="w-4 h-4" /> Excel</Btn>
          <Btn variant="ghost" data-testid="finance-dl-pdf" onClick={() => download(month, "pdf")}><FileText className="w-4 h-4" /> PDF</Btn></div>} />
      <div className="flex gap-2 mb-5 flex-wrap">
        {[["summary", "Ringkasan"], ["bank", "Kas Bank"], ["po", "Tagihan PO"], ["daily", "Uang Harian Mingguan"], ["ent", "Biaya Entertainment"]].map(([k, l]) => (
          <button key={k} data-testid={`finance-tab-${k}`} onClick={() => setTab(k)} className={`px-4 py-2 rounded-lg text-sm font-medium ${tab === k ? "bg-slate-900 text-white" : "border border-slate-300"}`}>{l}</button>))}
      </div>
      {tab === "summary" && <Summary d={d} />}
      {tab === "bank" && <Bank />}
      {tab === "po" && <PoPayments />}
      {tab === "daily" && <DailyRelease />}
      {tab === "ent" && <SalesEntertain />}
    </div>
  );
}
